import { action, IReactionDisposer, observable, reaction, makeObservable } from "mobx"
import { isClient } from "utils/is-client"
import { Events } from "abstract/events"

export class AuthStore {
  @observable
  public token?: string

  private readonly activateAutosave = (): IReactionDisposer => reaction(
    () => this.token,
    token => {
      if (token) localStorage.setItem("token", token)
      else localStorage.removeItem("token")
    },
  )

  constructor() {
    if (isClient) this.token = localStorage.getItem("token") || undefined
    makeObservable(this)
    if (!isClient) return

    this.activateAutosave()

    window.addEventListener(Events.JWT_EXPIRED, () => {
      this.clearToken()
    })
  }

  @action
  private clearToken() {
    this.token = undefined
  }
}
